// config for screensize thresholds and settings
var config = {
    multiSize: {
        large: 1150,
        medium: 660,
        small: 400
    }
};


/**
 * On page load
 **/
$(document).ready( function(){
	PageSetup();
});

function PageSetup(){
    MobileNav();
    ToggleContent();
}

function MobileNav(){
    $('.hamburglar').click( function(){
    	$(this).toggleClass('open');
        $('.burglar-container, body, .mainnav, .page-header').toggleClass ('active');        
    });
}

function ToggleContent(){
    $('.toggle-button').click(function(e){
    	e.preventDefault();
        $(this).parents('.togglable').children('.togglable-content').slideToggle(200);
        $(this).toggleClass('open');
        if( $(this).children('.fa').length ){
            $(this).children('.fa').toggleClass('fa-caret-right');
        	$(this).children('.fa').toggleClass('fa-caret-down');
        }
    });
}

/**
 * Multi-size graphics
 * These allow us to load the relevant image size, depending on the size of the screen
 * By default we load a mobile-sized image initially, and swap to larger pics if applicable
 **/
function ResponsiveBG(){

    $('.responsive-bg').each( function( key, panel ){

        if($(this).inView('both')){

            panel = $(panel);
            var panelWidth = $(window).outerWidth();
            
            if( panelWidth > config.multiSize.large && panel.data('large') ){

                if( panel.is( 'img') ) {
                    panel.delay(1000).attr( 'src', panel.data('large') );
                } else {
                    panel.delay(1000).css({ 'background-image': 'url('+ panel.data('large') +')' });
                }
                
            }else if( panelWidth > config.multiSize.medium && panel.data('medium') ){
                
                if( panel.is( 'img') ) {
                    panel.attr( 'src', panel.data('medium') );
                } else {
                    panel.css({'background-image': 'url('+ panel.data('medium') +')' });
                }
                
            }else if(panel.data('small')){
                
                if( panel.is( 'img') ) {
                    panel.attr( 'src', panel.data('small') );
                } else {
                    panel.css({'background-image': 'url('+ panel.data('small') +')' });
                }

            }

            panel.removeClass('loading');

        }
        
    });

}
